const checkFitment = /* GraphQL */ `
  query CheckFitment($skuBase: String, $skuVariant: String, $checkFitmentRequest: [CheckFitmentRequestDMInput]) {
    checkFitment: checkFitmentNew(
      skuBase: $skuBase
      skuVariant: $skuVariant
      checkFitmentRequest: $checkFitmentRequest
    ) {
      fitment {
        key
        value {
          fits
          isDirectFit
          isDrivelineFit
          isUniversalFit
          shopUrl
          partialFit
          needsMoreInfo
          promptUserFor
          requiresAdapter
          adapterSkuNumber
          unverifiedEngineUsed
          additionalEngineLevelFacets {
            type
            displayName
            facets {
              id
              name
              hasVersionNotDisplacement
            }
          }
        }
      }
    }
  }
`

export default checkFitment
